<template>
  <v-container v-if="claim.DOC_ID" class="pr-0 pl-0">
    <div v-if="claim.COMMENTS_TAB && claim.COMMENTS_TAB.length" style="height: 60vh; overflow-y: auto; overflow-x: hidden;" class="grey lighten-2">
      <div
        v-for="item in claim.COMMENTS_TAB"
        :key="item.COMMENT_ID"
        >
        <v-row v-if="item.OWN_COMMENT">
          <v-col cols="10" offset="2"><claim-comment-card :comment="item"></claim-comment-card></v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="10" align-self="start"><claim-comment-card :comment="item"></claim-comment-card></v-col>
        </v-row>
      </div>
    </div>
    <div class="fill-height grey lighten-2" v-else>
      <v-row align="center" justify="center" class="fill-height">
        <v-col class="text-center">
          Нет переписки по выбранному запросу
        </v-col>
      </v-row>
    </div>
    <div class="pt-2 pl-2 pr-2" style="border: 1px solid #bbbbbb">
      <v-textarea
        outlined
        dense
        class="mt-2"
        rows="1"
        auto-grow
        background-color="white"
        v-model="commentText"
        label="Новый комментарий"
        append-outer-icon="mdi-send blue--text"
        @click:append-outer="sendComment"
      ></v-textarea>
    </div>
  </v-container>
  <v-row v-else align="center" justify="center" class="fill-height">
    <v-col class="text-center">
      Выберите запрос в списке слева
    </v-col>
  </v-row>
</template>

<script>
import ClaimCommentCard from '@/components/modules/claims/cards/claimCommentCard'
import { CLM_CHANGE_COMMENT } from '@/store/actions/claims'
import { UI_SNACKBAR } from '@/store/actions/ui'
export default {
  name: 'claimCommentsList',
  components: { ClaimCommentCard },
  props: ['claim'],
  data: () => ({
    commentText: null
  }),
  methods: {
    sendComment () {
      console.log('sendComment event called', this.commentText)
      if (!this.commentText.trim()) {
        return
      }
      const params = {
        DOC_ID: this.claim.DOC_ID,
        DOC_COMMENT: this.commentText,
        INST_ID: this.claim.INST_ID
      }
      this.$store.dispatch(CLM_CHANGE_COMMENT, params)
        .then(() => {
          this.$store.commit(UI_SNACKBAR, { color: 'green lighten-1', text: 'Комментарий добавлен успешно' })
          this.commentText = ''
        })
        .catch(err => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: err })
        })
    }
  }
}
</script>

<style scoped>

</style>
